import { Box, styled, Typography } from '@mui/material';

export const EmptyStateContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
  padding: 200px 20px;
`;

export const IconContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;

  svg {
    width: 200px;
    height: 200px;

    @media screen and (max-height: 768px) {
      width: 150px;
      height: 150px;
    }
  }
`;

export const MessageText = styled(Typography)(
  ({ theme }) => `
    color: ${theme.palette.text.secondary};
    font-size: 1.125rem;
    font-weight: 400;
    text-align: center;
`,
);
